export class BaseSheet {
  sheet_code: string
  name: string
  subject_code: string
  page_count: number
  
  constructor(base_sheet: any){
    this.sheet_code = base_sheet.sheet_code;
    this.name = base_sheet.name;
    this.subject_code = base_sheet.subject_code;
    this.page_count = base_sheet.page_count;
  }
}

export class Sheet {
  course_code: string
  campus_code: string
  class_code: string

  constructor(sheet: any){
    this.course_code = sheet.course_code;
    this.campus_code = sheet.campus_code;
    this.class_code = sheet.class_code;
  }
}

export class SheetActivity{
  id: number = 0
  student_id: number = 0
  page: number = 0
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  base64Image: string | null = null

  constructor(sa: any){
    this.id = sa.id;
    this.student_id = sa.student_id;
    this.page = sa.page;
  }
 }

 export class Examinee{
  id: number = 0
  student_no: number
  student_code: number
  student_name: string
  submitted_at: string
  submitted_at_cache: string
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  isSelected: boolean = false
  times: number

  constructor(examinee: any, sheet_activities: any[]){
    this.id = examinee.id;
    this.student_no = examinee.student_no;
    this.student_code = examinee.student_code;
    this.student_name = examinee.student_name;
    this.submitted_at = examinee.submitted_at;
    this.submitted_at_cache = examinee.submitted_at;
    this.times = examinee.times;
    const sheetActivities = new Array<SheetActivity>();
    sheet_activities.filter((x: any) => x.student_id == this.student_no).forEach((x: any) => {
      sheetActivities.push(new SheetActivity(x));
    });
    
    this.sheetActivities = sheetActivities.sort((a: SheetActivity, b: SheetActivity) => a.page < b.page ? -1 : 1);
  }
}

export class SearchCondition {
  student_code: string = ""
  student_name: string = ""
  submitted_at_from: string = ""
  submitted_at_to: string = ""
}